// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3oK43","insightsList":"newBusinessInsightsMenu_insightsList__3Zp4K","active":"newBusinessInsightsMenu_active__25LBS"};